if (!customElements.get('product-upsells')) {
  customElements.define(
    'product-upsells',
    class ProductUpsells extends HTMLElement {
      constructor() {
        super();
        this.forms = this.querySelectorAll('.upsell-form');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.initForms();
      }

      initForms() {
        this.forms.forEach((form) => {
          form.addEventListener('submit', this.onSubmitHandler.bind(this));
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        // Get the form element - currentTarget is the form the listener is attached to
        const form = evt.currentTarget || evt.target;
        if (!form || !form.classList.contains('upsell-form') || !form.closest('product-upsells')) {
          return;
        }

        const button = form.querySelector('.upsell-button');
        if (!button || button.hasAttribute('aria-disabled')) return;

        const plusIcon = button.querySelector('.upsell-button__icon--plus');
        const loadingIcon = button.querySelector('.upsell-button__icon--loading');
        const checkIcon = button.querySelector('.upsell-button__icon--check');

        // Show loading state
        button.setAttribute('aria-disabled', 'true');
        plusIcon.classList.add('hidden');
        loadingIcon.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(form);

        let sectionsToRender = [{ id: 'cart-icon-bubble' }];
        if (this.cart) {
          sectionsToRender = sectionsToRender.concat(this.cart.getSectionsToRender());
          this.cart.setActiveElement(document.activeElement);
        }

        formData.append(
          'sections',
          sectionsToRender.map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Handle error - show error state briefly then reset
              setTimeout(() => {
                this.resetButton(button, plusIcon, loadingIcon, checkIcon);
              }, 1000);
              return;
            }

            // Update cart icon bubble
            this.updateCartIconBubble(response);

            // Update cart drawer if present (similar to product-form.js pattern)
            if (this.cart && !this.cart.classList.contains('is-empty')) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-upsells',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                if (typeof CartPerformance !== 'undefined') {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(response);
                  });
                } else {
                  this.cart.renderContents(response);
                }
              });
            }

            // Show success state (checkmark)
            loadingIcon.classList.add('hidden');
            checkIcon.classList.remove('hidden');

            // Reset to plus icon after 2 seconds
            setTimeout(() => {
              this.resetButton(button, plusIcon, loadingIcon, checkIcon);
            }, 2000);
          })
          .catch((error) => {
            console.error('Error adding product to cart:', error);
            // Reset on error
            this.resetButton(button, plusIcon, loadingIcon, checkIcon);
          });
      }

      updateCartIconBubble(response) {
        if (response.sections && response.sections['cart-icon-bubble']) {
          const cartIconBubble = document.getElementById('cart-icon-bubble');
          if (cartIconBubble) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = response.sections['cart-icon-bubble'];
            const newSectionContent = tempDiv.querySelector('#shopify-section-cart-icon-bubble');
            if (newSectionContent) {
              cartIconBubble.innerHTML = newSectionContent.innerHTML;
            }
          }
        }
      }

      resetButton(button, plusIcon, loadingIcon, checkIcon) {
        button.removeAttribute('aria-disabled');
        loadingIcon.classList.add('hidden');
        checkIcon.classList.add('hidden');
        plusIcon.classList.remove('hidden');
      }
    }
  );
}

